export const iconFontAwesomeHouseholdSink = (
	<i className="fa-solid fa-sink"></i>
);
